import React, { ReactNode, useRef, useState, useEffect } from 'react';
import { ParallaxBanner } from 'react-scroll-parallax';

interface ParallaxSectionProps {
  backgroundImage: string;
  children: ReactNode;
  id?: string;
}

const ParallaxSection: React.FC<ParallaxSectionProps> = ({
  backgroundImage,
  children,
  id
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div id={id} className="relative w-full py-8 md:py-12">
      <div ref={ref} className="max-w-screen-lg mx-auto px-4 relative z-10 mb-6">
        <div className={`bg-white rounded-xl shadow-lg p-8 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          {children}
        </div>
      </div>

      <ParallaxBanner
        layers={[
          {
            image: backgroundImage,
            speed: -20,
            expanded: false,
            opacity: [0.8, 1],
          }
        ]}
        className="h-[30vh] md:h-[50vh]"
      />
    </div>
  );
};

export default ParallaxSection;
